import React from 'react';
import buildConfig from 'utils/buildConfig';
import PageHead from 'components/misc/PageHead';
import { Group } from 'entity/group/groupRedux';

const communityDefaultSeo = {
  pageTitle: 'Personal Finance Community - Seedly',
  ogType: 'website',
  ogTitle: 'Personal Finance Community - Seedly',
  ogDescription:
    'Join the discussion on personal finance question and answer community. Be more financially literate.',
  ogImage: `${buildConfig.s3BucketEndpoint}/share/questions.png`,
  keywords:
    'personal finance community, hacks, advice, questions, answers, investments, deals, savings, singapore',
};

const configureCommunityPageHead = (group: Group) => {
  let props: any = {};

  if (group) {
    props.pageTitle = `${group.name} - `;
    props.ogUrl = `${buildConfig.apiHost}/community/${group.slug}`;
    props.ogType = 'website';
    props.ogTitle = group.name;
    props.ogImage = group.profileImage || communityDefaultSeo.ogImage;
    props.ogDescription =
      group.description || communityDefaultSeo.ogDescription;
    props.keywords = communityDefaultSeo.keywords;
    const url = `${buildConfig.apiHost}/community/${group.slug}`;
    props.canonicalUrl = url;
  } else {
    props = { ...communityDefaultSeo };
    props.canonicalUrl = `${buildConfig.apiHost}/community/`;
    props.pageTitleHasPostfix = false;
  }

  return props;
};

const CommunityPageHead = (props: { group: Group }) => {
  return <PageHead {...configureCommunityPageHead(props.group)} />;
};

export default CommunityPageHead;
